var _path, _g, _path2, _path3, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 32,
    viewBox: "0 0 52 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_3840",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H25.7561V32H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_3840)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7202 15.9998C19.7202 10.9136 22.0806 6.38518 25.7562 3.45455C23.0463 1.29377 19.6223 -0.000366211 15.8963 -0.000366211C7.11706 -0.000366211 0 7.16322 0 15.9998C0 24.8365 7.11706 32.0001 15.8963 32.0001C19.6223 32.0001 23.0463 30.7059 25.7562 28.5451C22.0806 25.6145 19.7202 21.0861 19.7202 15.9998Z",
    fill: "#EC2026"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5122 16.3903C19.5122 21.4532 21.9539 25.9609 25.7561 28.8781C29.5583 25.9609 32 21.4532 32 16.3903C32 11.3273 29.5583 6.81967 25.7561 3.90247C21.9539 6.81967 19.5122 11.3273 19.5122 16.3903Z",
    fill: "#F16A21"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_3840",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 0,
    width: 27,
    height: 32
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7561 0H51.5122V32H25.7561V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_3840)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.616 -0.00012207C31.89 -0.00012207 28.4665 1.2936 25.7561 3.45481C29.4313 6.38546 31.7921 10.9139 31.7921 16.0002C31.7921 21.086 29.4313 25.6149 25.7561 28.5455C28.4665 30.7063 31.89 32 35.616 32C44.3953 32 51.5124 24.8369 51.5124 16.0002C51.5124 7.1635 44.3953 -0.00012207 35.616 -0.00012207Z",
    fill: "#F89F1D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardIcon);
export default __webpack_public_path__ + "static/media/mastercard-icon.ffc34c49730cdf8b97d9a0802a4f54d6.svg";
export { ForwardRef as ReactComponent };